import { useState, useEffect, useRef } from "react";
import {
  Text,
  Center,
  Box,
  FormControl,
  FormLabel,
  Input,
  Flex,
  VStack,
  Link,
} from "@chakra-ui/react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import "./signin.css";
import ScrollAnimation from "react-animate-on-scroll";

import { useAuthContext } from "../auth-check/authContext";
import { checkAuth } from "./auth";

export default function SignInForm() {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [error, setError] = useState("");
  var [input, setInput] = useState({
    user_email: "",
    user_password: "",
  });
  const { setIsAuthed, setToken } = useAuthContext(); //destructing useAuthContext
  const handleChange = (event) => {
    input[event.target.name] = event.target.value;
    setInput(input);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    checkAuth(input.user_email, input.user_password)
      .then((response) => {
        setIsAuthed(true);
        setToken(response.data.token);
        navigate("/dashboard", { replace: true });
      })
      .catch((error) => {
        setIsAuthed(false);
        setError(error.response.data);
        navigate("/signin");
      });
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <Box
      id='signin'
      display='flex'
      flexDir='column'
      justifyContent='center'
      className='sign-in'
    >
      <ScrollAnimation animateIn='fadeIn'>
        <Box
          width={{
            base: "85%",
            md: "60%",
            xl: "50%",
          }}
          border='10px'
          boxShadow='md'
          p={5}
          rounded='md'
          bg='rgba(31, 159, 181, 0.6)'
          mr='auto'
          ml='auto'
          mb='5%'
        >
          <Flex flexDir='column' zIndex={0}>
            <VStack>
              <Box>
                <Center>
                  <Text
                    color='white'
                    fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                    fontWeight={700}
                  >
                    Sign In
                  </Text>
                </Center>
              </Box>
            </VStack>
            <form onSubmit={handleSubmit}>
              <FormControl id='email' isRequired>
                <FormLabel color='white' fontSize='18px'>
                  Email address
                </FormLabel>
                <Input
                  type='email'
                  placeholder='type your email here'
                  name='user_email'
                  _focus={{
                    zIndex: "0",
                    borderColor: "#3182ce",
                  }}
                  onChange={handleChange}
                  value={input.email}
                  color='white'
                  ref={inputRef}
                />
              </FormControl>

              <FormControl id='password' isRequired>
                <FormLabel color='white' fontSize='18px'>
                  Password
                </FormLabel>
                <Input
                  type='password'
                  placeholder='type your password here'
                  name='user_password'
                  _focus={{
                    zIndex: "0",
                    borderColor: "#3182ce",
                  }}
                  onChange={handleChange}
                  value={input.password}
                  color='white'
                />
              </FormControl>
              {error ? (
                <div>
                  <Text color='red' fontSize='18px' fontWeight={700}>
                    {error.error}
                  </Text>
                </div>
              ) : (
                <div></div>
              )}
              <Box
                as='button'
                mt='2%'
                p={2}
                color='white'
                fontWeight='bold'
                borderRadius='md'
                bgGradient='linear(to-r, teal.500,green.500)'
                _hover={{
                  bgGradient: "linear(to-r, red.500, yellow.500)",
                }}
                type='submit'
                value='Submit'
              >
                Log In
              </Box>
            </form>
          </Flex>
          <Text color='white' fontSize='18px'>
            Don't have an account? You can Sign Up {""}
            <Link to='/signup' as={RouterLink} color='#180d59' fontWeight={700}>
              here!
            </Link>
          </Text>
        </Box>
      </ScrollAnimation>
    </Box>
  );
}
